import { z } from "zod";

export const AttributeSchema = z.object({
  type: z.string(),
  value: z.string(),
});
